<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>訂單詳情</p>
      </div>

      <el-form>
        <el-form-item label="訂單編號:"><!-- 订单编号 -->
          <input disabled class="el-input__inner" maxlength="100" type="text" v-model="orderInfo.orderNum">
        </el-form-item>

        <el-form-item label="品項:"><!-- 品项 -->
          <input disabled maxlength="100" class="el-input__inner" type="text" v-model="orderInfo.skuName">
        </el-form-item>

        <el-form-item label="規格:"><!-- 规格 -->
          <input maxlength="100" class="el-input__inner" type="text" v-model="orderInfo.sku">
        </el-form-item>

        <el-form-item label="数量:"><!-- 数量 -->
          <el-input-number v-model="orderInfo.num" :controls='false' @change="changeSelectValue"
                           :min="1"></el-input-number>
        </el-form-item>

        <el-form-item label="付款方式:">
          <input disabled class="el-input__inner" maxlength="100" type="text" v-model="orderInfo.payMethod">
        </el-form-item>

        <el-form-item label="訂單金額:">
          <input disabled maxlength="100" class="el-input__inner" type="text" v-model="orderInfo.payMoney">
        </el-form-item>

        <el-form-item label="地區:">
          <input disabled maxlength="100" class="el-input__inner" type="text" v-model="orderInfo.area">
        </el-form-item>

        <el-form-item label="訂單狀態:">
          <el-select v-model="orderInfo.orderStatus" placeholder="請選擇訂單狀態">
            <el-option label="待出貨" value="11"></el-option><!-- 已付款 -->
            <el-option label="已出貨" value="5"></el-option>
            <el-option label="訂單完成" value="6"></el-option>
            <el-option label="退件" value="10"></el-option>
            <el-option :disabled='orderStatusDis' label="訂單取消" value="8"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="物流公司:">
          <input maxlength="100" class="el-input__inner" type="text" v-model="orderInfo.logistics">
        </el-form-item>
        <el-form-item label="貨運單號:">
          <input maxlength="100" class="el-input__inner" type="text" v-model="orderInfo.trackingNumber">
        </el-form-item>

        <el-form-item label="創建時間:">
          <el-date-picker
            disabled
            v-model="orderInfo.orderTime"
            type="datetime"
            placeholder="选择时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="付款時間:">
          <el-date-picker
            disabled
            v-model="orderInfo.payTime"
            type="datetime"
            placeholder="">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>會員資料</p>
      </div>

      <el-form>
        <el-form-item label="用戶賬號:"><!-- 用户账号 -->
          <input disabled maxlength="100" class="el-input__inner" type="text" v-model="memberInfo.userAccount">
        </el-form-item>

        <el-form-item label="真實姓名:"><!-- 真实姓名 -->
          <input disabled maxlength="100" class="el-input__inner" type="text" v-model="memberInfo.realName">
        </el-form-item>

        <el-form-item label="手機號碼:">
          <input disabled maxlength="100" class="el-input__inner" type="text" v-model="memberInfo.phoneNo">
        </el-form-item>

        <el-form-item label="地址:">
          <input disabled maxlength="100" class="el-input__inner" type="text" v-model="memberInfo.userAdress">
        </el-form-item>

      </el-form>

      <div class="detailsTitle">
        <div class="detailsWrap"></div>
        <p>收件人資料</p>
      </div>
      <el-form>
        <el-form-item label="收件人姓名:">
          <input maxlength="100" placeholder="請填寫正確姓名，以利收件" class="el-input__inner" type="text"
                 v-model="receiverInfo.receiverName">
        </el-form-item>
        <el-form-item label="手機號碼:">
          <el-input maxlength="100" placeholder="請填寫正確手機號碼，以利收件"
                    @change="receiverInfo.receiverPhone = receiverInfo.receiverPhone.replace(/\D/g,'')" type="text"
                    v-model="receiverInfo.receiverPhone"></el-input>
        </el-form-item>

        <el-form-item label="郵遞區號:">
          <el-input maxlength="100"
                    @change="receiverInfo.receiverZipcode=receiverInfo.receiverZipcode.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\$%\^&\*\\\/]/g,'')"
                    type="text" v-model="receiverInfo.receiverZipcode"></el-input>
        </el-form-item>

        <el-form-item label="收件地址:">
          <!-- <el-cascader
              :value="receiverarea"
              placeholder="請選擇省市區"
              ref="cascaderAddr"
              :options="this.$Address.data"
              @change="handleAreaChange">
          </el-cascader> -->
          <input
            class='addrInput'
            placeholder="請輸入省份"
            v-model="receiverInfo.receiveCountry"/>
          <input
            class='addrInput'
            placeholder="請輸入城市"
            v-model="receiverInfo.receiveCity"/>
          <input
            class='addrInput'
            placeholder="請輸入區域"
            v-model="receiverInfo.receiveRegion"/>
          <input
            class='addrInput detailsInput'
            placeholder="請輸入詳細地址"
            v-model="receiverInfo.receiverAddr"/>
        </el-form-item>

        <el-form-item label="備註:">
          <el-input
            type="textarea"
            autosize
            placeholder="請輸入備註內容"
            v-model="receiverInfo.remark">
          </el-input>
        </el-form-item>

      </el-form>
      <div class="bottomBtn">
        <div class="btn" @click="submitModify">修改</div>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';

export default {
  data() {
    return {
      navBlock: '訂單  /  ' + this.$route.query.navBlock + '訂單',
      navtitle: '修改詳情',
      orderNum: this.$route.query.orderNum,
      id: this.$route.query.id,
      orderStatusDis: true,
      unitPrice: '', //商品单价
      infNum: '', // 商品原本的数量
      infId: '', //商品的goodsId
      masterOrderStatus: '',
      orderInfo: {
        orderNum: '',
        skuName: '',
        sku: '',
        num: '',
        payMethod: '',
        payMoney: '',
        area: '', // 地区
        orderStatus: '', // 订单状态
        logistics: '', //物流公司
        trackingNumber: '', // 物流单号
        orderTime: '', // 订单创建时间
        payTime: '' // 订单付款时间
      },
      memberInfo: {
        userAccount: '', // 用户账号
        realName: '', // 真实姓名
        phoneNo: '', // 手机账号
        userAdress: '', // 地址
      },
      receiverInfo: {
        receiverName: '',
        receiverPhone: '',
        receiverZipcode: '',
        receiverAddr: '', // 详细地址
        receiveCountry: '',
        receiveCity: '',
        receiveRegion: '',
        receiverFullAddr: '',// 完整地址
        remark: ''
      },
      receiverarea: [],// 收件人地址省市區
      dialogVisible: false,

    }
  },
  created() {
    let _this = this;
    _this.getDetails();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    getDetails() {
      let _this = this;
      let param = {
        orderNum: _this.orderNum
      }
      _this.$post('/request/order/getOrderList', param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          console.log(res)
          if (res.code === '00000') {
            let info = res.data.list[0];
            _this.receiverarea = [info.country, info.city, info.region]
            let order = info.orderDetailDto[_this.getIndex(info.orderDetailDto, _this.id)];
            _this.infNum = order.goodsAmount;
            _this.infId = order.goodsId,
              _this.unitPrice = order.goodsRecievablePrice / order.goodsAmount;// 商品單價
            _this.masterOrderStatus = info.orderStatus;//存儲原本訂單狀態
            _this.orderInfo = {
              orderNum: info.orderNum,
              skuName: order.goodsName,
              sku: order.goodsDetail,
              num: order.goodsAmount,
              payMethod: info.payMethod,
              payMoney: order.goodsRecievablePrice+ ' ' + info.currency,
              area: ((info.country === null ? '' : info.country) + ' ' + (info.city === null ? '' : info.city) + '').toString(),
              orderStatus: info.orderStatus,
              logistics: info.trackingCompany, //物流公司
              trackingNumber: info.trackingNumber,
              orderTime: info.createTime,
              payTime: info.payTime
            }
            _this.memberInfo = {
              userAccount: info.memberDto.email,
              realName: info.memberDto.realname,
              phoneNo: '+' + info.memberDto.areaCode + info.memberDto.mobile,
              userAdress: info.memberDto.country + info.memberDto.city + info.memberDto.area + info.memberDto.address,
            }
            _this.receiverInfo = {
              receiverName: info.receiver,
              receiverPhone: info.receivePhone,
              receiverZipcode: info.receiveCode,
              receiverAddr: info.address,
              receiverFullAddr: info.receiveAddr,
              receiveCountry: info.country,
              receiveCity: info.city,
              receiveRegion: info.region,
              remark: info.managerRemark,
            }
          } else {
            _this.$propMessage(res.message, 'error');
          }
        })
    },
    // 地区选择
    handleAreaChange(val) {
      let _this = this;
      _this.receiverarea = _this.$refs['cascaderAddr'].getCheckedNodes()[0].pathLabels;
      _this.receiverInfo.receiveCountry = _this.receiverarea[0];
      _this.receiverInfo.receiveCity = _this.receiverarea[1];
      _this.receiverInfo.receiveRegion = _this.receiverarea[2];
    },
    // 获取当前数据在数组中的index
    getIndex(arr, dst) {
      let index = '';
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id == dst) {
          index = i;
        }
      }
      return index
    },
    // 数量选择
    changeSelectValue(val) {
      let _this = this;
      _this.orderInfo.num = val;
      _this.orderInfo.payMoney = _this.unitPrice * val + ' TWD';
    },
    // 修改提交
    submitModify() {
      let _this = this;
      let fullAdress = '';
      if (_this.orderInfo.skuName === '' || _this.orderInfo.skuName === null || _this.$getCaption(_this.orderInfo.skuName)) {
        _this.dialogVisible = true;
        _this.$propMessage('品項不能為空或者含有非法字符', 'error',
          function () {
            _this.dialogVisible = false;
          });
        return false;
      }
      ;

      // if (_this.orderInfo.sku === '' || _this.orderInfo.sku === null || _this.$getCaption(_this.orderInfo.sku)) {
      //   _this.dialogVisible = true;
      //   _this.$propMessage('規格不能為空或者含有非法字符','error',
      //     function(){
      //       _this.dialogVisible = false;
      //     });
      //   return false;
      // };

      if (_this.orderInfo.num === '' || _this.orderInfo.num === null || _this.orderInfo.num === undefined) {
        _this.dialogVisible = true;
        _this.$propMessage('數量不能為空', 'error',
          function () {
            _this.dialogVisible = false;
          });

        return false;
      }

      if (_this.receiverInfo.receiverName === '' || _this.receiverInfo.receiverName === null || _this.$getCaption(_this.receiverInfo.receiverName)) {
        _this.dialogVisible = true;
        _this.$propMessage('收件人姓名不能為空', 'error',
          function () {
            _this.dialogVisible = false;
          });

        return false;
      }
      ;

      if (_this.receiverInfo.receiverPhone === '' || _this.receiverInfo.receiverPhone === null) {
        _this.dialogVisible = true;
        _this.$propMessage('收件人手機號碼不能為空', 'error',
          function () {
            _this.dialogVisible = false;
          });

        return false;
      }
      ;

      if (_this.receiverInfo.receiveCountry == '' || _this.receiverInfo.receiveCity == '') {
        _this.dialogVisible = true;
        _this.$propMessage('請輸入完整省市區', 'error',
          function () {
            _this.dialogVisible = false;
          });

        return false;
      }

      if (_this.receiverInfo.receiverAddr === '' || _this.receiverInfo.receiverAddr === null) {
        _this.dialogVisible = true;
        _this.$propMessage('請輸入詳細地址', 'error',
          function () {
            _this.dialogVisible = false;
          });

        return false;
      }
      ;

      let orderStatus = null;
      if (_this.orderInfo.orderStatus == _this.masterOrderStatus) {
        switch (_this.orderInfo.orderStatus) {
          case '待付款':
            orderStatus = 1
            break;
          case '已付款':
            orderStatus = 2
            break;
          case '付款失敗':
            orderStatus = 3
            break;
          case '已過期':
            orderStatus = 4
            break;
          case '已出貨':
            orderStatus = 5
            break;
          case '已完成':
            orderStatus = 6
            break;
          case '審核中':
            orderStatus = 7
            break;
          case '訂單取消':
            orderStatus = 8
            break;
          case '審核失敗':
            orderStatus = 9
            break;
          case '退件':
            orderStatus = 10
            break;
          case '待出貨':
            orderStatus = 11
            break;
        }
      } else {
        orderStatus = Number(_this.orderInfo.orderStatus);
      }
      _this.$confirm('確定修改此訂單詳情?', '提示信息', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        center: true,
        closeOnClickModal: false
      }).then(() => {
        let orderParam = {
          id: _this.id,
          infId: _this.infId,
          size: _this.orderInfo.sku, // 品項
          number: _this.orderInfo.num, // 數量
          infNum: _this.infNum, //原始数量
          address: _this.receiverInfo.receiveCountry,
          unitPrice: _this.unitPrice,
        }
        let param = {
          orderNum: _this.orderNum,
          orderStatus: orderStatus,
          trackingCompany: _this.orderInfo.logistics,//物流公司
          trackingNumber: _this.orderInfo.trackingNumber,//物流单号
          receiver: _this.receiverInfo.receiverName,
          receivePhone: _this.receiverInfo.receiverPhone,
          receiveCode: _this.receiverInfo.receiverZipcode,
          receiveAddr: _this.receiverInfo.receiveCountry + _this.receiverInfo.receiveCity + _this.receiverInfo.receiveRegion + _this.receiverInfo.receiverAddr + '', // 完整地址
          managerRemark: _this.receiverInfo.remark,
          country: _this.receiverInfo.receiveCountry, // 省
          city: _this.receiverInfo.receiveCity, // 市
          region: _this.receiverInfo.receiveRegion, // 区
          address: _this.receiverInfo.receiverAddr, // 详细地址
        }

        _this.$post('request/member/updateOrderGooofSn', orderParam, _this.$GLOBAL.jsonConfig)
          .then((res) => {
            if (res.code === '00000') {
              _this.$post('/request/order/editOrderDetails', param, _this.$GLOBAL.jsonConfig)
                .then((adreeRes) => {
                  _this.dialogVisible = true;
                  if (adreeRes.code === '00000') {
                    _this.$propMessage('修改詳情成功', 'success',
                      function () {
                        _this.dialogVisible = false;
                        _this.$router.go(-1);
                      });

                  } else if (adreeRes.code === '40002') {

                    if (adreeRes.data === '包含非法字符') {
                      _this.$propMessage('輸入內容不能包含非法字符，請重試', 'error',
                        function () {
                          _this.dialogVisible = false;
                        });

                    } else {
                      // _this.$Mint.Toast(res.message);
                      _this.$propMessage(res.message, 'error',
                        function () {
                          _this.dialogVisible = false;
                        });

                    }
                  } else {
                    // _this.$Mint.Toast();
                    _this.$propMessage(res.message, 'error',
                      function () {
                        _this.dialogVisible = false;
                      });
                  }
                });

            } else if (res.code === '40002') {

              if (res.data === '包含非法字符') {
                _this.$propMessage('輸入內容不能包含非法字符，請重試', 'error',
                  function () {
                    _this.dialogVisible = false;
                  });

              } else {
                _this.$propMessage(res.message, 'error',
                  function () {
                    _this.dialogVisible = false;
                  });
              }

            } else {
              _this.$propMessage(res.message, 'error',
                function () {
                  _this.dialogVisible = false;
                });
            }
          })
      }).catch(() => {

      });

    },
  },
  components: {
    NavBar,
    DiaMess,
  }
};
</script>
<style lang="less" scoped>
input:disabled {
  width: 100%;
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #C0C4CC;
  cursor: not-allowed;
}

input.addrInput {
  background: #E8E6F0;
  color: rgba(147, 142, 164);
  border: none;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  cursor: pointer;
  padding-left: 0.14rem;
  border-radius: 5px;
}

input.addrInput:focus {
  background: #fff;
  border: 1px solid #6c3dea;
}

input.addrInput:placeholder {
  color: rgba(147, 142, 164);
}

input.detailsInput {
  width: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/outOrderDetails.vue